export {
        resolve, createResolver, type Elements, type ElementsDescriptors
    } from "MWL@2026/infrastructure/DOM/ElementsResolver";

export { ShadowTemplate, type ShadowTemplateArgs } from "MWL@2026/infrastructure/DOM/ShadowTemplate";
export {html} from "MWL@2026/infrastructure/DOM/ShadowTemplate/parsers/html";